
import { defineComponent, ref, onMounted } from "vue";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import axios from "@/axios-instance"
import moment from "moment"
import Permission from "@/core/config/Permission";
import { debounce } from "debounce";
import ICountUp from 'vue-countup-v3';
import { useRoute } from "vue-router";
import { statusTagDefault } from "@/components/customers/ProfileDetailInfor.vue";


interface ICustomer {
  id: string;
  fullName: string;
  phoneNumber: string;
  school: string;
  province: string;
  date: string;
  checkbox: boolean;
}
interface IPagination {
  currentPage: number;
  total: number;
  limit: number;
}
export default defineComponent({
  name: "customers-listing",
  components: {
    Datatable,
    ICountUp,
  },
  watch: {
    search: debounce(async function (this) {
      this.searchItems()
    }, 300)
  },
  data() {
    return {
      checkDefault: false,
      loading: false,
      schoolDetail: {} as any,
    }
  },
  methods: {
    async getData(page = 1, limit = 50) {
      this.loading = true
      this.tableData = []
      this.initCustomers = []
      let filter = {
        "filter": {
            class12ProvinceId: 0,
            class12SchoolId: +this.route.params.id,
            hasAmount: 2,
            month: 0,
            prProvinceId: 0,
        }
      }
      await axios.post(`/admission/student/filter`,filter)
      .then(( {data} ) => {
        data.students.forEach((item,index) => {
          let temp = { 
            index: index +1,
            fullName: item.fullName,
            location: item['class12Province.name'],
            school: item['class12School.name'],
            phoneNumber: item.phone,
            id: item.id,
            idCard: item.idCard,
            date: moment(item.createdAt).format('DD/MM/YYYY'),
            checkbox: true,
            numberProfile: item.amount,
            status: item.status,
            highschoolGraduation: item.highschoolGraduation,
            lastModifiedBy: item.lastModifiedBy?item.lastModifiedBy.split('_')[0]:'',
          }
          this.tableData.push(temp as any)
        })
        this.initCustomers.splice(0, this.tableData.length, ...this.tableData);
        this.loading = false
      })
      .catch(({ response }) => {
        console.log('err',response)
      });
      this.loading = false
    },
    currentChange(currentPage,limit = 0) {
       if(limit == 0) {
        limit = this.pagination.limit
      }
      else {
        this.pagination.limit = limit
      }
      this.getData(currentPage,this.pagination.limit)
    }
  },
  async created() {
    
    await this.getData()
    await axios.get(`/stat/adreg/school/?schoolid=${this.route.params.id}`)
    .then(( {data} ) => {
        this.schoolDetail = data[0]
    })
    .catch(({ response }) => {
        console.log('err',response)
    });
  },
  setup() {
    const route = useRoute()
    const pagination = ref<IPagination>({
      currentPage: 1,
      total: 0,
      limit: 25,
    });
    const checkedCustomers = ref([]);
    const tableHeader = ref([
      {
        name: "STT",
        key: "index",
        sortable: true,
        class: "w-50px",
      },
      {
        name: "HỌ TÊN",
        key: "fullName",
        sortable: true,
      },
      {
        name: "SĐT",
        key: "phoneNumber",
        sortable: true,
      },
      {
        name: "CMND/CCCD",
        key: "idCard",
        sortable: true,
      },

      {
        name: "SỐ HỒ SƠ",
        key: "numberProfile",
        sortable: false,
        class:"text-center",
      },
      {
        name: "NGÀY ỨNG TUYỂN",
        key: "date",
        sortable: false,
        class: " ",
      },
      {
        name: "Chi tiết",
        key: "viewMore",
        sortable: false,
        class: "text-center w-130px"
      },
    ]);
    
    const tableData = ref<Array<ICustomer>>([]);
    const initCustomers = ref<Array<ICustomer>>([]);
    const statusTag =  statusTagDefault
    onMounted(async () => {
       //getData()
      //initCustomers.value.splice(0, tableData.value.length, ...tableData.value);
      //console.log(tableData.value)
    });
    const deleteCustomer = async (id) => {
      for (let i = 0; i < tableData.value.length; i++) {
        if (tableData.value[i].id === id) {
          tableData.value.splice(i, 1);
        }
      }
      for (let i = 0; i < initCustomers.value.length; i++) {
        if (initCustomers.value[i].id === id) {
          initCustomers.value.splice(i, 1);
          return
        }
      }
    };
    const search = ref<string>("");
    const searchItems = () => {
      
      tableData.value.splice(0, tableData.value.length, ...initCustomers.value);
      if (search.value !== "") {
        let results: Array<ICustomer> = [];
        for (let j = 0; j < tableData.value.length; j++) {
          if (searchingFunc(tableData.value[j], search.value)) {
            results.push(tableData.value[j]);
          }
        }
        tableData.value.splice(0, tableData.value.length, ...results);
      }
    };

    const searchingFunc = (obj, value): boolean => {
      obj = JSON.parse(JSON.stringify(obj))
      obj.status = statusTag[obj.status]?.label
      for (let key in obj) {
        if (obj[key] && (typeof obj[key] === "string")) {
          if (obj[key].toUpperCase().indexOf(value.toUpperCase()) != -1) {
            return true;
          }
        }
      }
      return false;
    };

    return {
      tableData,
      initCustomers,
      tableHeader,
      deleteCustomer,
      search,
      searchItems,
      checkedCustomers,
      pagination,
      statusTag,
      Permission,
      route
    };
  },
});
